import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import Select from "react-select";
import Axios from "axios";
import { Notyf } from "notyf";
import server from "../variables";

const AddUserModal = ({ show, handleClose, schemeID, refresh, editData,user }) => {
  const notyf = new Notyf();
  const [loading, setLoading] = useState(false);
   console.log('user',user)
  const roleList = [
    { label: "Manager", value: "manager" },
    { label: "Field", value: "field" },
    { label: "Monitoring", value: "monitoring" },
  ];

  const defaultForm = {
    name: "",
    email: "",
    password: "",
    remarks: "",
    role: "",
  };

  const [form, setForm] = useState(defaultForm);

  useEffect(() => {
    if (editData) {
      setForm({
        name: editData.name || "",
        email: editData.email || "",
        password: "",
        remarks: editData.remarks || "",
        role: editData.role || "",
      });
    } else {
      setForm(defaultForm);
    }
  }, [editData, show]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleRoleChange = (data) => setForm({ ...form, role: data?.value || "" });

// const submitUser = async () => {
//   if (!form.name || !form.email || (!editData && !form.password) || !form.role) {
//     return notyf.error("Please fill all required fields");
//   }

//   setLoading(true);
//   try {
//     let endpoint = server + "admin/new-user"; // default: create
//     let payload = { ...form, scheme: schemeID };

//     if (editData) {
//       // Update user via REST-style URL
//       endpoint = server + "admin/update-user/" + editData.userID;

//       // Don't send password if it's empty
//       if (!form.password) {
//         delete payload.password;
//       }
//     }

//     const { data } = await Axios.post(endpoint, payload, {
//       headers: { authorization: localStorage.getItem("token") },
//     });

//     if (data.status === 200) {
//       notyf.success(editData ? "User updated successfully" : "User registered successfully");
//       handleClose();
//       refresh();
//       setForm({
//         name: "",
//         email: "",
//         password: "",
//         remarks: "",
//         role: "",
//       });
//     } else {
//       notyf.error(data.message || "Something went wrong");
//     }
//   } catch (err) {
//     console.error(err);
//     notyf.error("Internal Server Error");
//   } finally {
//     setLoading(false);
//   }
// };


const isUser = user === true || user === "true";
console.log(isUser)
const submitUser = async () => {
  if (!form.name || !form.email || (!editData && !form.password) || !form.role) {
    return notyf.error("Please fill all required fields");
  }

  setLoading(true);

  try {
    let endpoint = "";
    let payload = { ...form };

    /* ================= USER FLOW ================= */
    if (isUser) {
 
      if (editData) {
    endpoint = server + "user/update-user/" + editData.userID;

        // password optional on edit
        if (!form.password) delete payload.password;
      } else {
        // USER CREATE API
        endpoint = server + "user/new-user";
      }
    }

    /* ================= ADMIN FLOW ================= */
    else {
      endpoint = server + "admin/new-user";
      payload = { ...form, scheme: schemeID };

      if (editData) {
        endpoint = server + "admin/update-user/" + editData.userID;

        if (!form.password) {
          delete payload.password;
        }
      }
    }

    const { data } = await Axios.post(endpoint, payload, {
      headers: { authorization: localStorage.getItem("token") },
    });

    if (data.status === 200) {
      notyf.success(editData ? "User updated successfully" : "User registered successfully");
      handleClose();
      refresh();
      setForm({
        name: "",
        email: "",
        password: "",
        remarks: "",
        role: "",
      });
    } else {
      notyf.error(data.message || "Something went wrong");
    }
  } catch (err) {
    console.error(err);
    notyf.error("Internal Server Error");
  } finally {
    setLoading(false);
  }
};



  if (!show) return null;

  // Custom styles for react-select
  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      borderRadius: "0.375rem",
      borderColor: "#ced4da",
      boxShadow: "none",
      "&:hover": { borderColor: "#86b7fe" },
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    placeholder: (base) => ({
      ...base,
      color: "#6c757d",
    }),
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={handleClose}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content rounded-4 shadow-sm">
          {/* Modal Header */}
          <div className="modal-header bg-light">
            <h5 className="modal-title">{editData ? "Edit User" : "Add New User"}</h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>

          {/* Modal Body */}
          <div className="modal-body bg-light p-4">
            <div className="mb-3">
              <TextField
                label="User Name *"
                fullWidth
                name="name"
                value={form.name}
                onChange={handleChange}
                size="small"
              />
            </div>

            <div className="mb-3">
              <TextField
                label="Email *"
                fullWidth
                name="email"
                value={form.email}
                onChange={handleChange}
                size="small"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Role *</label>
              <Select
                options={roleList}
                value={roleList.find((r) => r.value === form.role) || null}
                onChange={handleRoleChange}
                placeholder="Select role"
                styles={selectStyles}
                isSearchable
              />
            </div>

            <div className="mb-3">
              <TextField
                label="Remarks"
                fullWidth
                multiline
                rows={3}
                name="remarks"
                value={form.remarks}
                onChange={handleChange}
                size="small"
              />
            </div>

            <div className="mb-4">
              <TextField
                label={editData ? "Password (Leave blank to keep current)" : "Password *"}
                type="password"
                fullWidth
                name="password"
                value={form.password}
                onChange={handleChange}
                size="small"
              />
            </div>

            <button
              className="btn btn-primary w-100 py-2"
              onClick={submitUser}
              disabled={loading}
            >
              {loading && <span className="spinner-border spinner-border-sm me-2"></span>}
              {editData ? "Update User" : "Register User"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;
